import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <div style={{ position: "fixed", bottom: "24px", right: "40px", zIndex: 9999 }}>
          <div data-widget-key="3bd3f7eb-6e8c-4a10-8dcb-ef4cb9632fc1"></div>
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
